<div ngxMasonryItem class="masonry-item">
  <div class="card hero-card">
    <div class="gallery-view mt-0">
      <div class="row">
        <div class="col-12">
          <!-- No loading="lazy" here: ngx-masonry's ordered mode waits for each item's
               images before revealing the next, and a below-fold lazy image never starts
               loading — the whole feed would stall. -->
          <img [src]="article?.mainImage" (load)="onLoad()" onerror="this.onerror=null;this.src='../assets/images/no-image.svg'"
            [alt]="article?.title || 'Article image'" />
        </div>
      </div>
    </div>
    <div class="card-head">
      <h4 class="card-title">
        {{article.title?.length >30? article.title?.substring(0,30)+'...' : article.title}}
        <!-- <img src="./assets/images/ic-leaf.svg" alt="Icon" /> -->
      </h4>
    </div>
    <div class="card-body">
      <p class="food-info">
        {{article.description?.length >118? article.description?.substring(0,118)+'...' :
        article.description }}
      </p>
      <div *ngIf="showMutlipleImage && article.carouselData?.Images?.length" class="gallery-view three-by-two ">
        <div class="row">
          <div class="col-4 dashboard-article-small-img" *ngFor="let img of article.carouselData?.Images;let i=index">
            <img *ngIf="i<3" [src]="img" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
